'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'police-box';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e021';
var svgPathData = ['M48 96l0 400 288 0 0-400c0-8.8-7.2-16-16-16l-5.2 0L312 80 72 80l-1.5 0L64 80c-8.8 0-16 7.2-16 16zM80 56l0 8 224 0 0-8c0-4.4-3.6-8-8-8L192 48 88 48c-4.4 0-8 3.6-8 8zm0 88c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zM208 144c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z', 'M200 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24L88 32C74.7 32 64 42.7 64 56l0 8C46.3 64 32 78.3 32 96l0 400L8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-400c0-17.7-14.3-32-32-32l0-8c0-13.3-10.7-24-24-24l-96 0 0-24zM336 96l0 400L48 496 48 96c0-8.8 7.2-16 16-16l6.5 0L72 80l240 0 2.8 0 5.2 0c8.8 0 16 7.2 16 16zM192 48l104 0c4.4 0 8 3.6 8 8l0 8L80 64l0-8c0-4.4 3.6-8 8-8l104 0zM96 272l64 0 0 64-64 0 0-64zm-16 0l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM288 144l0 24-24 0 0-24 24 0zm-64 0l24 0 0 24-24 0 0-24zm0 40l24 0 0 24-24 0 0-24zm64 24l-24 0 0-24 24 0 0 24zm-64-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm-88 16l24 0 0 24-24 0 0-24zm-16 0l0 24-24 0 0-24 24 0zm0 40l0 24-24 0 0-24 24 0zm16 24l0-24 24 0 0 24-24 0zM80 144l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoliceBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;